import { DocumentType } from 'shared/domains/apollo/generated/types';
import { isDocx } from '../fileHelpers';
export const isDocxDocument = (document) => {
    const { files = [] } = document || {};
    if (!document) {
        return false;
    }
    const isUploaded = document.type === DocumentType.Uploaded;
    const docxFile = files.find(isDocx);
    return isUploaded && Boolean(docxFile);
};
